import template from './operation.html';
import controller from './operation.controller';

const operationComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default operationComponent;
